import { privateAxios } from '@/services/api'

export const _getTeams = () => {
    return privateAxios.get('/teams')
        .then(response => response.data)
}

export const _createTeam = (data) => {
    return privateAxios.post('/teams', data)
        .then(response => response.data)
}

export const _updateTeam = (data) => {
    return privateAxios.patch('/teams', data)
        .then(response => response.data)
}

export const _updateTeamSettings = (data) => {
    return privateAxios.put('/teams/settings', data)
        .then(response => response.data)
}

export const _applyVoucher = (data) => {
    return privateAxios.post('/teams/vouchers', data)
        .then(response => response.data)
}

export const _updateTeamBilling = (data) => {
    return privateAxios.put('/teams/billing', data)
        .then(response => response.data)
}

export const _leaveCurrentTeam = () => {
    return privateAxios.patch('/teams/leave')
        .then(response => response.data)
}

export const _deleteTeam = () => {
    return privateAxios.patch('/teams/deactivate')
        .then(response => response.data)
}

export const _getTeamMembers = () => {
    return privateAxios.get('teams/members')
        .then(response => response.data)
}

export const _createTeamMember = (data) => {
    return privateAxios.post(`/teams/members`, data)
        .then(response => response.data)
}

export const _updateTeamMember = (id, data) => {
    return privateAxios.patch(`/teams/members/${id}`, data)
        .then(response => response.data)
}

export const _deleteTeamMember = (id) => {
    return privateAxios.delete(`/teams/members/${id}`)
        .then(response => response.data)
}

export const _verifyInvitation = (data) => {
    return privateAxios.post('/teams/members/verify', data)
        .then(response => response.data)
}

export const _acceptInvitation = (data) => {
    return privateAxios.post('/teams/members/accept', data)
        .then(response => response.data)
}

export const _transferTeam = (data) => {
    return privateAxios.post('teams/members/transfer-ownership', data)
        .then(response => response.data)
}
